// Material
export const MATERIAL_UNTITLED_SECTION = 'Untitled section';
